import { DELETE_WARNING, IconButton, Menu, MenuItem, Typography } from "@compass/core";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Comment } from "generated/openApi";
import { useState } from "react";
import ApiService from "services/apiService";

export const CommentsMenu = (props: {
  comment: Comment;
  setEditingComment: React.Dispatch<React.SetStateAction<Comment | undefined>>;
  onSaved: () => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const postDelete = (id: number) => {
    setAnchorEl(null);

    if (window.confirm(DELETE_WARNING)) {
      ApiService.comments.deleteComment(id).then((response) => {
        props.onSaved();
      });
    }
  };

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <ArrowDropDownIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            props.setEditingComment(props.comment);
            setAnchorEl(null);
          }}
        >
          Edit
        </MenuItem>
        <MenuItem onClick={() => postDelete(props.comment.id)}>
          <Typography color="error">Delete</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
